import * as React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { AlertTriangle } from 'lucide-react'

interface DeleteKnowledgeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  collectionName: string
  onConfirm: () => void | Promise<void>
}

export function DeleteKnowledgeDialog({
  open,
  onOpenChange,
  collectionName,
  onConfirm,
}: DeleteKnowledgeDialogProps) {
  const [confirming, setConfirming] = React.useState(false)

  const handleConfirm = async () => {
    setConfirming(true)
    try {
      await onConfirm()
    } finally {
      setConfirming(false)
      onOpenChange(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Delete Knowledge Collection
          </DialogTitle>
          <DialogDescription className="text-left space-y-3 pt-2" asChild>
            <div>
              <p>
                You are about to permanently delete <strong>{collectionName}</strong>.
              </p>
              <p>
                This will also delete the knowledge collection from the server and make it
                unavailable for <strong>all Origin Relay users</strong>.
              </p>
              <p className="text-destructive font-medium">
                This action cannot be undone.
              </p>
            </div>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <button
            onClick={() => onOpenChange(false)}
            disabled={confirming}
            className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={confirming}
            className="inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-medium bg-destructive text-destructive-foreground hover:bg-destructive/90 transition-colors"
          >
            {confirming ? 'Deleting…' : 'Delete Collection'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
